import type { AllRouteEndpoints } from "../routeTypes";
export const postReportingAppGroupIdMetricsQueryCacheKeys: AllRouteEndpoints[] = [];
